import { SetItem } from "@/models/SetItem";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { ImageGalleryDialogItemHelper } from "@/components/ImageGalleryDialog/ImageGalleryDialogItemHelper";
import { ImageGalleryDialogSetHelper } from "@/components/ImageGalleryDialog/ImageGalleryDialogSetHelper";

@Component<ImageSetGalleryDialog>({})
export default class ImageSetGalleryDialog extends Vue {

  // #region @VModels
  // #endregion

  // #region @Props

  @Prop({ required: true })
  protected currentSetId!: string;

  @Prop({ required: true })
  protected sets!: SetItem[];

  protected internalCurrentSetId: string = this.currentSetId;

  // #endregion

  // #region @Refs
  // #endregion

  // #region Class properties

  protected itemHelper = new ImageGalleryDialogItemHelper();

  protected setHelper = new ImageGalleryDialogSetHelper();

  // #endregion

  // #region Lifecycle Hooks / Init

  protected mounted(): void {
    this.initialize();
  }

  protected beforeDestroy(): void {
    this.deinitialize();
  }

  protected initialize(): void {
    this.internalCurrentSetId = this.currentSetId;
    this.$store.dispatch('setAppScrollbarForcedHidden', true);
  }

  protected deinitialize(): void {
    this.$store.dispatch('setAppScrollbarForcedHidden', false);
  }

  // #endregion

  // #region Class methods

  protected onClose(): void {
    this.$emit('close');
  }

  protected onNavigateToSet(setId: string | undefined): void {
    if (!setId) { return; }

    this.internalCurrentSetId = setId;
  }

  protected onNext(): void {
    if (! this.hasPageNext) { return; }

    this.internalCurrentSetId = this.sets[this.setIndex + 1].id || '';
  }

  protected onPrevious(): void {
    if (! this.hasPagePrevious) { return; }

    this.internalCurrentSetId = this.sets[this.setIndex - 1].id || '';
  }
  // #endregion

  // #region Async methods
  // #endregion

  // #region Getters & Setters

  protected get amountColumns(): number {
    if (this.$vuetify.breakpoint.xsOnly) {
      return 1;
    }

    if (this.$vuetify.breakpoint.smOnly) {
      return 1;
    }

    if (this.items.length === 1) {
      return 1;
    }

    if (this.$vuetify.breakpoint.mdOnly) {
      return 2;
    }

    if (this.items.length === 2) {
      return 2;
    }

    if (this.$vuetify.breakpoint.lgOnly) {
      return 3;
    }

    if (this.items.length === 3) {
      return 3;
    }

    if (this.items.length === 4) {
      return 4;
    }

    return 5;
  }

  protected get amountSets(): number {
    return this.sets.length;
  }

  protected get hasPageNext(): boolean {
    return !! this.sets[this.setIndex + 1];
  }

  protected get hasPagePrevious(): boolean {
    return this.setIndex > 0;
  }

  protected get items(): SetItem[] {
    return this.set.set_items || [];
  }

  protected get set(): SetItem {
    return this.sets[this.setIndex];
  }

  protected get setIndex(): number {
    return this.sets.findIndex((set) => set.id === this.internalCurrentSetId) as number;
  }
  // #endregion

  // #region @Watchers
  // #endregion
}

// #region Enums
// #endregion

// #region Types
// #endregion

// #region Interfaces
// #endregion
